document.addEventListener("click", (event) => {
  const toggle = event.target.closest("[data-menu-toggle]");
  if (toggle) document.querySelector("[data-mobile-menu]")?.classList.toggle("hidden");
});
document.addEventListener("change", (event) => {
  const select = event.target.closest("[data-variant-select]");
  if (!select) return;
  const form = select.closest("form");
  if (form) form.querySelector("[name=id]").value = select.value;
});

const updateCartCount = async () => {
  const response = await fetch("/cart.js", {
    headers: { Accept: "application/json" },
  });
  if (!response.ok) return;
  const cart = await response.json();
  const count = Number(cart.item_count) || 0;
  const label = count > 99 ? "99+" : String(count);
  document.querySelectorAll("[data-cart-count]").forEach((item) => {
    item.textContent = label;
  });
  document.querySelectorAll("[data-cart-count-badge]").forEach((item) => {
    item.classList.toggle("hidden", count === 0);
    item.hidden = count === 0;
  });
};

const refreshCartSection = async (form) => {
  const currentSection = form.closest("[data-cart-section]");
  const sectionId = currentSection?.dataset.cartSection;
  if (!currentSection || !sectionId) return false;

  const url = new URL(window.location.href);
  url.searchParams.set("section_id", sectionId);

  const response = await fetch(url.toString(), {
    headers: { "X-Requested-With": "XMLHttpRequest" },
  });
  if (!response.ok) return false;

  const html = await response.text();
  const doc = new DOMParser().parseFromString(html, "text/html");
  const nextSection = doc.querySelector("[data-cart-section]");
  if (!nextSection) return false;

  currentSection.replaceWith(nextSection);
  nextSection.querySelectorAll("script").forEach((oldScript) => {
    const script = document.createElement("script");
    Array.from(oldScript.attributes).forEach((attr) => {
      script.setAttribute(attr.name, attr.value);
    });
    script.textContent = oldScript.textContent;
    oldScript.replaceWith(script);
  });
  return true;
};

const refreshCollectionSection = async (targetUrl, section) => {
  const currentSection = section || document.querySelector("[data-collection-section]");
  const sectionId = currentSection?.dataset.collectionSection;
  if (!currentSection || !sectionId) return false;

  currentSection.classList.add("is-refreshing");
  const url = new URL(targetUrl, window.location.origin);
  const browserUrl = new URL(url.toString());
  url.searchParams.set("section_id", sectionId);

  try {
    const response = await fetch(url.toString(), {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    });
    if (!response.ok) return false;

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, "text/html");
    const nextSection = doc.querySelector("[data-collection-section]");
    if (!nextSection) return false;

    currentSection.replaceWith(nextSection);
    window.history.pushState({}, "", browserUrl.toString());
    initCollectionRatings(nextSection);
    return true;
  } finally {
    currentSection.classList.remove("is-refreshing");
  }
};

const initCollectionRatings = (scope = document) => {
  const gasUrl = "https://script.google.com/macros/s/AKfycbxmFEhMB2u7-DuV6GB3lkXSvYHNir5bG1BWnFNHDOYEFueLgRy-MgBZdJ22OFX0l5d5/exec";
  const items = scope.querySelectorAll("[data-collection-rating]");
  if (!items.length) return;
  const cacheKey = "burgkidz_collection_rating_cache_v1";

  const readCache = () => {
    try {
      return JSON.parse(window.sessionStorage.getItem(cacheKey) || "{}");
    } catch (error) {
      return {};
    }
  };

  const writeCache = (cache) => {
    try {
      window.sessionStorage.setItem(cacheKey, JSON.stringify(cache));
    } catch (error) {
      // Ignore cache write failures.
    }
  };

  const renderStars = (value) => {
    const count = Math.max(0, Math.min(5, Math.round(Number(value) || 0)));
    return Array.from({ length: 5 }, (_, index) => {
      const active = index < count;
      return `<svg width="11" height="11" viewBox="0 0 24 24" fill="${active ? "#FFF9E6" : "none"}" stroke="${active ? "#e6b800" : "#dfe3e4"}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>`;
    }).join("");
  };

  items.forEach((item) => {
    if (item.dataset.ratingInitialized === "true") return;
    item.dataset.ratingInitialized = "true";

    const handle = item.dataset.productHandle;
    const loading = item.querySelector("[data-collection-rating-loading]");
    const stars = item.querySelector("[data-collection-rating-stars]");
    const count = item.querySelector("[data-collection-rating-count]");
    if (!handle || !loading || !stars || !count) return;

    const applyRating = (payload) => {
      const reviews = Array.isArray(payload?.reviews) ? payload.reviews : [];
      const ratings = reviews
        .map((review) => Number(review?.rating))
        .filter((value) => Number.isFinite(value) && value >= 1 && value <= 5);
      const average = ratings.length ? ratings.reduce((total, value) => total + value, 0) / ratings.length : 0;
      stars.innerHTML = renderStars(average);
      count.textContent = `(${reviews.length})`;
      loading.hidden = true;
      stars.hidden = false;
      count.hidden = false;
    };

    const cache = readCache();
    if (cache[handle]) {
      applyRating(cache[handle]);
      return;
    }

    const callbackName = `renderCollectionRating${Date.now()}${Math.floor(Math.random() * 1000)}`;
    window[callbackName] = (data) => {
      try {
        const payload = { reviews: Array.isArray(data?.reviews) ? data.reviews : [] };
        applyRating(payload);
        cache[handle] = payload;
        writeCache(cache);
      } finally {
        delete window[callbackName];
        document.querySelector(`[data-collection-rating-jsonp="${callbackName}"]`)?.remove();
      }
    };

    const script = document.createElement("script");
    script.src = `${gasUrl}?handle=${encodeURIComponent(handle)}&callback=${callbackName}&_=${Date.now()}`;
    script.async = true;
    script.dataset.collectionRatingJsonp = callbackName;
    script.onerror = () => {
      delete window[callbackName];
      script.remove();
    };
    document.body.appendChild(script);
  });
};

document.addEventListener("submit", async (event) => {
  const form = event.target.closest('form[action*="/cart/add"]');
  if (!form || form.dataset.ajaxCartDisabled === "true") return;

  const variantInput = form.querySelector('[name="id"]');
  if (!variantInput || !variantInput.value) return;

  event.preventDefault();
  const button = form.querySelector('[type="submit"]');
  const originalText = button?.textContent;
  const originalHtml = button?.innerHTML;
  const canSwapText = Boolean(originalText && originalText.trim());

  if (button) {
    button.disabled = true;
    if (canSwapText) button.textContent = button.dataset.loadingText || "Adding...";
  }

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: new FormData(form),
    });
    if (!response.ok) throw new Error("add_to_cart_failed");
    await updateCartCount();
    if (button && canSwapText) button.textContent = button.dataset.successText || "Added";
    if (form.matches("[data-cart-recommendation-add]") && window.location.pathname.includes("/cart")) {
      const refreshed = await refreshCartSection(form);
      if (!refreshed) window.location.reload();
      return;
    }
    window.setTimeout(() => {
      if (button && originalHtml) button.innerHTML = originalHtml;
    }, 1400);
  } catch (error) {
    if (button && canSwapText) button.textContent = button.dataset.errorText || "Try again";
    window.setTimeout(() => {
      if (button && originalHtml) button.innerHTML = originalHtml;
    }, 1800);
  } finally {
    if (button) {
      window.setTimeout(() => {
        button.disabled = false;
      }, 350);
    }
  }
});

document.addEventListener("DOMContentLoaded", () => {
  initCollectionRatings(document);
});

document.addEventListener("submit", async (event) => {
  const form = event.target.closest("[data-collection-filter-form]");
  if (!form) return;

  event.preventDefault();
  const url = new URL(form.action, window.location.origin);
  new FormData(form).forEach((value, key) => {
    if (value !== "") url.searchParams.append(key, value);
  });

  const refreshed = await refreshCollectionSection(url.toString(), form.closest("[data-collection-section]"));
  if (!refreshed) window.location.href = url.toString();
});

document.addEventListener("change", (event) => {
  const sort = event.target.closest("[data-collection-sort]");
  if (!sort) return;
  sort.closest("form")?.submit();
});

document.addEventListener("click", (event) => {
  const collectionLink = event.target.closest(
    "[data-collection-section] .toy-filter-pill, [data-collection-section] .toy-filter-chip, [data-collection-section] .toy-filter-clear, [data-collection-section] .toy-page-nav a, [data-collection-section] .toy-empty-link"
  );
  if (collectionLink && collectionLink.href) {
    event.preventDefault();
    refreshCollectionSection(collectionLink.href, collectionLink.closest("[data-collection-section]")).then((refreshed) => {
      if (!refreshed) window.location.href = collectionLink.href;
    });
    return;
  }

  const filterOpen = event.target.closest("[data-toy-filter-open]");
  if (filterOpen) {
    const section = filterOpen.closest(".shopify-section");
    section?.classList.add("is-filter-open");
    return;
  }

  const filterClose = event.target.closest("[data-toy-filter-close]");
  if (filterClose) {
    const section = filterClose.closest(".shopify-section");
    section?.classList.remove("is-filter-open");
    return;
  }

  const thumb = event.target.closest("[data-product-thumb]");
  if (thumb) {
    const section = thumb.closest("[data-product-section]");
    const image = section?.querySelector("[data-product-main-image]");
    if (image) {
      image.classList.add("is-switching");
      window.setTimeout(() => {
        image.src = thumb.dataset.imageSrc;
        image.alt = thumb.dataset.imageAlt || image.alt;
        image.classList.remove("is-switching");
      }, 160);
    }
    section?.querySelectorAll("[data-product-thumb]").forEach((item) => {
      item.classList.remove("ring-2", "ring-[#486464]", "ring-offset-2", "shadow-md");
      item.classList.add("opacity-50");
    });
    thumb.classList.add("ring-2", "ring-[#486464]", "ring-offset-2", "shadow-md");
    thumb.classList.remove("opacity-50");
  }

  const minus = event.target.closest("[data-qty-minus]");
  const plus = event.target.closest("[data-qty-plus]");
  if (minus || plus) {
    const form = event.target.closest("form");
    const input = form?.querySelector("[data-qty-input]");
    if (!input) return;
    const current = Math.max(1, Number(input.value) || 1);
    input.value = minus ? Math.max(1, current - 1) : current + 1;
  }

  const tabButton = event.target.closest("[data-tab-button]");
  if (tabButton) {
    const tabs = tabButton.closest("[data-product-tabs]");
    const key = tabButton.dataset.tabButton;
    const panelsWrap = tabs?.querySelector("[data-tab-panels]");
    const currentPanel = tabs?.querySelector("[data-tab-panel].is-active");
    const nextPanel = tabs?.querySelector(`[data-tab-panel="${key}"]`);
    if (!tabs || !panelsWrap || !nextPanel || currentPanel === nextPanel) return;

    if (tabs._tabTimer) window.clearTimeout(tabs._tabTimer);
    if (tabs._tabHeightTimer) window.clearTimeout(tabs._tabHeightTimer);

    tabs?.querySelectorAll("[data-tab-button]").forEach((button) => {
      button.classList.remove("bg-[#486464]", "text-white", "shadow-md");
      button.classList.add("bg-[#f2f4f4]", "text-[#5b6061]");
      button.style.fontWeight = "500";
      button.setAttribute("aria-selected", "false");
    });
    tabButton.classList.add("bg-[#486464]", "text-white", "shadow-md");
    tabButton.classList.remove("bg-[#f2f4f4]", "text-[#5b6061]");
    tabButton.style.fontWeight = "700";
    tabButton.setAttribute("aria-selected", "true");

    const startHeight = panelsWrap.offsetHeight;
    panelsWrap.style.height = `${startHeight}px`;

    currentPanel?.classList.remove("is-active");
    currentPanel?.classList.add("is-leaving");

    nextPanel.querySelectorAll("[data-rating-bar]").forEach((bar) => {
      bar.style.width = "0%";
    });

    tabs._tabTimer = window.setTimeout(() => {
      currentPanel?.classList.add("hidden");
      currentPanel?.classList.remove("is-leaving");

      nextPanel.classList.remove("hidden");
      nextPanel.classList.remove("is-active");

      const endHeight = nextPanel.offsetHeight;
      panelsWrap.style.height = `${endHeight}px`;

      window.requestAnimationFrame(() => {
        nextPanel.classList.add("is-active");
        if (key === "reviews") {
          window.setTimeout(() => {
            nextPanel.querySelectorAll("[data-rating-bar]").forEach((bar) => {
              bar.style.width = bar.style.getPropertyValue("--rating-width") || "0%";
            });
          }, 80);
        }
      });

      tabs._tabHeightTimer = window.setTimeout(() => {
        panelsWrap.style.height = "";
      }, 320);
    }, 300);
  }

  const detailSummary = event.target.closest("[data-detail-accordion] summary");
  if (detailSummary) {
    event.preventDefault();
    const detail = detailSummary.closest("[data-detail-accordion]");
    const content = detail?.querySelector(".product-detail-content");
    if (!detail || !content || detail._detailAnimating) return;

    detail._detailAnimating = true;

    if (detail.open) {
      content.style.height = `${content.scrollHeight}px`;
      window.requestAnimationFrame(() => {
        content.style.height = "0px";
      });
      window.setTimeout(() => {
        detail.open = false;
        content.style.height = "";
        detail._detailAnimating = false;
      }, 310);
    } else {
      detail.open = true;
      content.style.height = "0px";
      window.requestAnimationFrame(() => {
        content.style.height = `${content.scrollHeight}px`;
      });
      window.setTimeout(() => {
        content.style.height = "";
        detail._detailAnimating = false;
      }, 310);
    }
  }
});

